module.exports = __webpack_public_path__ + "static/media/Keeper Of The Light.03dfc35c.png";